"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SNYK_POLICY_FILE = void 0;
exports.DEFAULT_SNYK_POLICY_FILE = '.snyk';
//# sourceMappingURL=invariants.js.map